var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalTwin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "7 7 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0049 12.8095L17.0176 14.4687M14.0049 12.8095L11.0075 14.4654L14 16.2985L17.0176 14.4687M14.0049 12.8095L13.9896 7.99532M17.0176 14.4687L17.004 10.0592L13.9896 7.99532M13.9896 7.99532C13.5357 8.36391 11.1639 9.83227 11.0239 10.0866L11.008 14.4654M10.1139 10.307C9.5156 10.4185 8.11834 9.9925 7.89248 10.7477C7.79678 11.0682 7.94279 16.5583 7.88154 17.4382L7.93678 17.4995L20.1124 17.4934C20.0976 16.6463 20.2442 11.0403 20.1343 10.7198C19.892 10.0106 18.5511 10.4114 17.9681 10.3064M21.0574 18.3416C20.3262 18.4505 15.6412 18.276 15.3781 18.3821C15.1337 18.48 15.2961 19.0471 14.6338 19.1811C14.5047 19.2073 13.4022 19.1871 13.2836 19.1423C12.7542 18.9443 12.8346 18.4991 12.7487 18.4149C12.6886 18.375 12.6087 18.3717 12.5393 18.3597C12.1455 18.293 8.08389 18.4406 7.111 18.3422C6.99396 18.3734 7.07435 19.139 7.4681 19.5666C7.72021 19.8401 8.06584 20.0134 8.43279 20.0627C10.2572 19.9637 18.6615 20.1923 19.594 20.0627C20.5619 19.9281 20.9081 19.2128 21.0569 18.3411L21.0574 18.3416Z",
    stroke: "#85E3C3",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalTwin);
export default __webpack_public_path__ + "static/media/digital-twin.81034744b2b722a3ad8fc37b1275d622.svg";
export { ForwardRef as ReactComponent };